import { createAction, props } from '@ngrx/store';

import { IncomingDeliveryListTabsEnum } from '../../enums';
import { IncomingDeliveriesListState } from '../reducers';

export const LoadIncomingDeliveriesList = createAction(
  '[Incoming Delivery] Load Incoming Deliveries List',
  props<{ incomingDeliveryListData: IncomingDeliveriesListState, status: IncomingDeliveryListTabsEnum, page: number }>()
);
